const hashPosition = ({ position }) => `${position.lat},${position.lng}`;
const isEqualPositionsAndOrder = (a, b) => {
  if (a === b) {
    return true;
  }
  if (a.length !== b.length) {
    return false;
  }
  const hashes = a.map(hashPosition);
  for (const [index, item] of b.entries()) {
    const hash = hashPosition(item);
    const hashIndex = hashes.indexOf(hash);
    if (hashIndex === -1) {
      return false;
    }
    if (hashes[index] !== hash) {
      return false;
    }
  }
  return true;
};
export {
  isEqualPositionsAndOrder
};
//# sourceMappingURL=is-equal-positions-and-order.js.map
